var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroductionAuthentification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0c-8.835 0-16 7.165-16 16 0 3.43 1.082 6.611 2.922 9.216l-34.451 34.451c-0.624 0.624-0.624 1.638 0 2.262 0.314 0.314 0.723 0.467 1.133 0.467s0.819-0.157 1.133-0.467l3.667-3.667 5.267 5.267c0.314 0.314 0.723 0.467 1.133 0.467s0.819-0.157 1.133-0.467c0.624-0.624 0.624-1.638 0-2.262l-5.267-5.267 2.538-2.538 5.267 5.267c0.314 0.314 0.723 0.467 1.133 0.467s0.819-0.157 1.133-0.467c0.624-0.624 0.624-1.638 0-2.262l-5.267-5.267 23.562-23.562c2.864 2.704 6.726 4.362 10.976 4.362 8.835 0 16-7.165 16-16s-7.165-16-16-16h-0.010zM57.050 25.050c-2.419 2.419-5.632 3.75-9.050 3.75s-6.634-1.331-9.050-3.75c-2.419-2.419-3.75-5.632-3.75-9.050s1.331-6.634 3.75-9.050c2.419-2.419 5.632-3.75 9.050-3.75s6.634 1.331 9.050 3.75c2.419 2.419 3.75 5.632 3.75 9.050s-1.331 6.634-3.75 9.050v0z",
    fill: "#223654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroductionAuthentification);
export default __webpack_public_path__ + "static/media/introduction-authentification.900382b4b7d1926090bd96bd637d18d9.svg";
export { ForwardRef as ReactComponent };